import { useMutation } from '@tanstack/react-query';
import { bulkRejectBankOperation } from 'config/requests/bankOperations';
import { queryClient } from 'providers/queryClient';

export function useBulkRejectRequestsBankOps() {
  const mutation = useMutation({
    mutationFn: ({ ids, comment }: { ids: number[]; comment: string }) =>
      bulkRejectBankOperation(ids, comment),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['bank_operations/pending_statuses'] });
    },
  });

  return { bulkRejectRequestsBankOps: mutation };
}
